"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTasProxy = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ImageCaption = _interopRequireDefault(require("./ImageCaption"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _links = require("../_utils/links");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      margin: theme.spacing(2, 0, 8, 0),
      '.aem-ms-cmp &': {
        margin: 0
      }
    },
    image: {
      display: 'block',
      width: '100%'
    }
  };
});
var ImageEditConfig = {
  emptyLabel: 'Image',
  isEmpty: function isEmpty(props) {
    return !(props.src != null && props.src.length > 0 || typeof props.src != 'undefined');
  }
};
var renditions = {
  xs: 300,
  sm: 640,
  md: 800,
  lg: 1200,
  xl: 1600,
  og: 0
};
var getTasProxy = function getTasProxy(src) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!size) return src;
  var isJpg = src.substr(-4) === '.jpg';
  var isPng = src.substr(-4) === '.png';
  var isTas = src.includes('/deepweb/');
  var width = renditions[size] || 0;
  if (!width) return src;
  if (isTas && (isJpg || isPng)) {
    return src.substr(0, src.length - 4) + '_w' + width + src.substr(-4);
  }
  return src;
};
exports.getTasProxy = getTasProxy;
var Image = function Image(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    title = _ref.title,
    link = _ref.link,
    uuid = _ref.uuid,
    widths = _ref.widths,
    displayPopupTitle = _ref.displayPopupTitle,
    caption = _ref.caption,
    captionTitle = _ref.captionTitle,
    classesInjected = _ref.classesInjected,
    anchorId = _ref.anchorId,
    size = _ref.size,
    imageLoadHandler = _ref.imageLoadHandler;
  var classesDefault = useStyles();
  var classes = classesInjected ? classesInjected : classesDefault;
  var imgSrc = getTasProxy(src, size);
  var linkProps = link && (0, _links.getTarget)(link);
  var hasTitle = displayPopupTitle === false && title;
  var hasPopupTitle = displayPopupTitle === true && title;
  var hasCaption = caption || captionTitle;
  var shouldRenderCaption = hasTitle && hasCaption;
  var _useState = (0, _react.useState)(title !== 'undefined' && title ? title : alt),
    titleVal = _useState[0],
    setTitleVal = _useState[1];
  var imageElement = __jsx("img", {
    src: imgSrc,
    alt: alt,
    className: (0, _clsx.default)(classes.image, 'aem-ms-image-cmp--img'),
    "data-cmp-hook-image": "image",
    title: titleVal,
    "data-cmp-is": "image",
    onLoad: function onLoad() {
      window.dispatchEvent(new Event('resize'));
      imageLoadHandler && imageLoadHandler(true);
    },
    onMouseEnter: function onMouseEnter() {
      setTitleVal('');
    },
    onMouseLeave: function onMouseLeave() {
      setTitleVal(title !== 'undefined' && title ? title : alt);
    }
  });

  //Responsive image resolutions provided by AEM via data hooks.
  //See AEM Image Component docs.
  return __jsx("div", {
    id: anchorId,
    className: (0, _clsx.default)(classes.wrapper, 'aem-ms-image-cmp'),
    "data-cmp-src": src,
    "data-cmp-widths": widths,
    "data-asset-id": uuid
  }, link && link.length > 0 && __jsx("a", (0, _extends2.default)({
    href: link,
    className: "aem-ms-image-cmp--link",
    "data-cmp-hook-image": "link"
  }, linkProps), imageElement), (!link || link.length === 0) && imageElement, shouldRenderCaption && __jsx(_ImageCaption.default, {
    caption: caption,
    captionTitle: captionTitle
  }), hasPopupTitle && __jsx("meta", {
    content: caption
  }));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/image')(Image, ImageEditConfig);
exports.default = _default;